import { Check } from "lucide-react";

interface ConsultationCardProps {
  type: string;
  title: string;
  description: string;
  price: string;
  features: string[];
  icon: string;
  iconBgColor: string;
  selected: boolean;
  onSelect: (type: string) => void;
  register: any; // Use appropriate type from react-hook-form
  additionalInfo?: string;
}

export const ConsultationCard = ({
  type,
  title,
  description,
  price,
  features,
  icon,
  iconBgColor,
  selected,
  onSelect,
  register,
  additionalInfo,
}: ConsultationCardProps) => {
  return (
    <div
      className={`cursor-pointer rounded-xl border-2 lg:p-6 p-4 transition-all ${selected ? "border-[#4272DD] ring-2 ring-[#4272DD]/20" : "border-[#E5E7EB] hover:border-[#D1D5DB]"}`}
      onClick={() => onSelect(type)}
    >
      <div className="flex flex-col space-y-4">
        <div
          className={`w-12 h-12 rounded-full flex items-center justify-center ${iconBgColor}`}
        >
            <img src={icon} alt="icon" />
        </div>

        <div className="flex items-start justify-between w-full">
          <div className="flex-1">
            <h3 className="text-[20px] font-semibold mb-1">{title}</h3>
            <p className="text-sm text-[#4B5563] mb-3">{description}</p>

            {additionalInfo && (
                <p className="text-sm font-medium text-[#1A202C] mb-2">{additionalInfo}</p>
            )}

            <div className="space-y-2">
              {features.map((feature, index) => (
                <div key={index} className="flex items-center space-x-2">
                  <div className="w-4 h-4 bg-[#4272DD] rounded-full flex items-center justify-center">
                    <Check className="w-3 h-3 text-white" />
                  </div>
                  <span className="text-sm text-[#4B5563]">{feature}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="text-right flex-shrink-0">
            <p className="text-[32px] font-medium">{price}</p>
          </div>
        </div>
      </div>

      <input
        type="radio"
        {...register("consultationType")}
        value={type}
        className="hidden"
        checked={selected}
        onChange={() => {}}
      />
    </div>
  );
}; 